module.exports = __webpack_public_path__ + "img/arrow-top.4b905780.svg";